import React, {useEffect, useRef, useState} from "react";
import TitleBar from "../../components/popUp/TitleBar";
import ChartTitle from "../../components/charts/ChartTitle";
import {getChart1Data, getChart2Data, getChart3Data} from "../../api/apiClient";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const options1 = {
  chart: {
    type: "column",
    backgroundColor: 'rgba(255, 255, 255, 0)',
    height: 163,
  },
  colors: [
    'rgba(80, 209, 178, 0.4)'
  ],
  accessibility: {
    description:
        "",
  },
  title: {
    text: "",
  },
  subtitle: {
    text:
        '',
  },
  xAxis: {
    categories: [
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
    ],
    allowDecimals: false,
    labels: {
      style: {
        // color: 'rgba(80, 209, 178, 0.4)',
        // backgroundColor: 'rgba(80, 209, 178, 0.4)'
      },
    },
    accessibility: {
      rangeDescription: "",
    },
    tickInterval: 3,
  },
  yAxis: {
    title: {
      text: "",
    },
    labels: {
      formatter: function () {
        return this.value;
      },
      style: {},
    },
  },
  plotOptions: {
    area: {
      pointStart: 0,
      marker: {
        enabled: true,
        symbol: "circle",
        radius: 3,
        states: {
          hover: {
            enabled: true,
          },
        },
      },
      fillOpacity: 0.5,
    },

  },
  series: [
    {
      name: "",
      data: [
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
      ],
      maker: {
        enabled: true
      }
    },
  ],
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  }
};

const options2 = {
  chart: {
    backgroundColor: 'rgba(255, 255, 255, 0)',
    height: 163,
  },
  colors: [
    'rgba(80, 209, 178, 0.4)',
    'rgba(250, 209, 178, 0.4)'
  ],
  accessibility: {
    description:
        "",
  },
  title: {
    text: "",
  },
  subtitle: {
    text:
        '',
  },
  xAxis: {
    categories: [
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
    ],
    allowDecimals: false,
    labels: {
      style: {},
    },
    accessibility: {
      rangeDescription: "",
    },
    tickInterval: 5,
  },
  yAxis: [{
    title: {
      text: "",
    },
  }, {
    title: {
      text: "",
    },
    opposite: true,
  }],
  plotOptions: {
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: false
      }
    }
  },
  series: [
    {
      name: "",
      type: 'column',
      yAxis: 0,
      data: [
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
      ],
      maker: {
        enabled: true
      }
    },
    {
      name: "",
      type: 'column',
      yAxis: 0,
      data: [
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
      ],
      maker: {
        enabled: true
      }
    },
    {
      name: "",
      type: 'spline',
      yAxis: 1,
      data: [
        0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01,
        0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01,
        0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01,
      ],
      maker: {
        enabled: true
      },
      color: '#c21414',
    },
  ],
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  }
};

const options3 = {
  chart: {
    type: "column",
    backgroundColor: 'rgba(255, 255, 255, 0)',
    height: 163,
  },
  colors: [
    'rgba(80, 209, 178, 0.4)',
    'rgba(250, 209, 178, 0.4)'
  ],
  accessibility: {
    description:
        "",
  },
  title: {
    text: "",
  },
  subtitle: {
    text:
        '',
  },
  xAxis: {
    categories: [
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
      '10-01', '10-02', '10-03', '10-04', '10-05',
    ],
    allowDecimals: false,
    labels: {
      style: {},
    },
    accessibility: {
      rangeDescription: "",
    },
    tickInterval: 3,
  },
  yAxis: {
    title: {
      text: "",
    },
  },
  plotOptions: {},
  series: [
    {
      name: "",
      data: [
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
      ],
      maker: {
        enabled: true
      }
    },
    {
      name: "",
      data: [
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
        100, 150, 120, 100, 140, 130, 150, 100, 100, 100,
      ],
      maker: {
        enabled: true
      }
    },

  ],
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  }
};


/* 대시보드 - 플랫폼 - 장애 및 성능 */
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
}

const FailurePerformance = () => {
  const nameChart1 = useRef();
  const [chart1option, setChart1option] = useState([options1]);
  const [chart2option, setChart2option] = useState([options2]);
  const [chart3option, setChart3option] = useState([options3]);

  useEffect(() => {
    updateChart1();
    updateChart2();
    updateChart3();
  }, []);


  useEffect(() => {

  }, [chart1option]);


  const initChart1 = (options) => {
    let newOptions = options;

    let newCategory = [];
    for (let i = 0; i < 30; i++) {
      newCategory[i] = '10-' + i;
    }
    newOptions.xAxis.categories = newCategory;

    let newSeries = []
    for (let i = 0; i < 30; i++) {
      newSeries[i] = getRandomInt(0, 100);
    }
    newOptions.series[0].data = newSeries;

    setChart1option(newOptions);
  };

  const initChart2 = (options) => {
    let newOptions = options;

    let newCategory = []
    for (let i = 0; i < 30; i++) {
      newCategory[i] = '10-' + i;
    }
    newOptions.xAxis.categories = newCategory;

    let newSeries1 = []
    for (let i = 0; i < 30; i++) {
      newSeries1[i] = getRandomInt(0, 100);
    }
    newOptions.series[0].data = newSeries1

    let newSeries2 = []
    for (let i = 0; i < 30; i++) {
      newSeries2[i] = getRandomInt(0, 100);
    }
    newOptions.series[1].data = newSeries2

    setChart2option(newOptions);
  };

  const initChart3 = (options) => {
    let newOptions = options;
    let newCategory = [];
    for (let i = 0; i < 30; i++) {
      newCategory[i] = '10-' + i;
    }
    newOptions.xAxis.categories = newCategory;

    let newSeries1 = [];
    for (let i = 0; i < 30; i++) {
      newSeries1[i] = getRandomInt(0, 100);
    }
    newOptions.series[0].data = newSeries1;

    let newSeries2 = [];
    for (let i = 0; i < 30; i++) {
      newSeries2[i] = getRandomInt(0, 100);
    }
    newOptions.series[1].data = newSeries2;

    setChart3option(newOptions);
  };

  const updateChart1 = () => {
    let newOptions = options1;
    getChart1Data(0, 0)
        .then(res => {
          const list = res.data.data.chartFireList;

          let category = [], series = [];
          // eslint-disable-next-line array-callback-return
          list.map(elem => {
            category.push(elem.mesure_dt.substr(5,));
            series.push(elem.cnt);
          });

          newOptions.xAxis.categories = category;
          newOptions.series[0].data = series;
          newOptions.series[0].name = '화재건수'

          setChart1option(newOptions);
        })
  };

  const updateChart2 = () => {
    let newOptions = options2;
    getChart2Data(0, 0).then(res => {
      const list = res.data.data.chartNetworksList;

      let category = [], series1 = [], series2 = [], ratio = [], temp = 0.0;
      list.map(elem => {
        category.push(elem.mesure_dt.substr(5,));
        series1.push(elem.suss_cnt);
        series2.push(elem.fail_cnt);
        temp = parseFloat((elem.fail_cnt / (elem.suss_cnt + elem.fail_cnt)).toFixed(2));
        ratio.push(temp);
      });

      newOptions.xAxis.categories = category;
      newOptions.series[0].data = series1;
      newOptions.series[0].name = '송신시도수'
      newOptions.series[1].data = series2;
      newOptions.series[1].name = '송신실패수';
      newOptions.series[2].data = ratio;
      //console.log(series2 / (series1 + series2));
      newOptions.series[2].name = 'PER';

      setChart2option(newOptions);
    })
  };

  const updateChart3 = () => {
    let newOptions = options3;
    getChart3Data(0, 0)
        .then(res => {
          const list = res.data.data.chartSystemsList;

          let category = [], series1 = [], series2 = [];
          // eslint-disable-next-line array-callback-return
          list.map(elem => {
            category.push(elem.mesure_dt.substr(5,));
            series1.push(elem.web_avg);
            series2.push(elem.db_avg);
          });

          newOptions.xAxis.categories = category;
          newOptions.series[0].data = series1;
          newOptions.series[0].name = 'Web 응답성능';
          newOptions.series[1].data = series2;
          newOptions.series[1].name = 'DB 응답성능';

          setChart3option(newOptions);
        })
  };


  return (
      <div className={"content-container"}>
        <TitleBar title={"장애 및 성능"}/>
        <div className={"content-container-body"}>
          <div className={"content-container-body-item m-2"}>
            <ChartTitle title={"일별 화재 발생 현황"}/>
            <HighchartsReact ref={nameChart1} highcharts={Highcharts} options={chart1option}/>
          </div>
          <div className={"content-container-body-item m-2"}>
            <ChartTitle title={"일별 무선망 성능 현황"}/>
            <HighchartsReact highcharts={Highcharts} options={chart2option}/>
          </div>
          <div className={"content-container-body-item m-2"}>
            <ChartTitle title={"일별 DB 성능 현황"}/>
            <HighchartsReact highcharts={Highcharts} options={chart3option}/>
          </div>
        </div>
      </div>
  );
};

export default FailurePerformance;